import Vue from 'vue';
import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import moment from 'moment';
import { saveAs } from 'file-saver';
import numeral from 'numeral';
import { stat } from 'fs';
import { _callOnClient } from '@sentry/minimal';

interface DealReportsState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;


    filter: {
        employeeId: any;
        targetDate: Date;
        new_only: boolean;
        with_hidden: boolean;
        new: boolean;
    };

    data: any;
    ds: any[];
}

const state: DealReportsState = {
    loading: false,
    loaded: true,
    fatalError: false,

    filter: {
        employeeId: null,
        targetDate: new Date(),
        new_only: false,
        new: false,
        with_hidden: false,
    },
    data: null,

    ds: [],
};

function buildFilter(params: any) {
    const queryParams: any = {}

    if (params.targetDate) {
        queryParams.date = moment(params.targetDate).format('YYYY-MM-DD');
    }

    if (params.employeeId) {
        // console.log(params.dManagers)
        // params.dManagers = params.dManagers.filter((item: any) => item != null)
        queryParams.employee_id = params.employeeId;
    }
    queryParams.new_only = params.new_only;
    queryParams.with_hidden = params.with_hidden;
    
    if (params.sortField !== null) {
        queryParams.order_by = params.sortField || 'client_name';
        queryParams.order_type = params.sortDirection || 'asc';
    }

    queryParams.no_group = params.no_group ? params.no_group : ''

    return queryParams;
}

export const REPORT_DATA = 'REPORT_DATA';

export const actions: ActionTree<DealReportsState, RootState> = {

    loadData({ commit, state, dispatch }, params) {
        const vm = (this as any)._vm;

        const new_only = params.new_only != undefined ? params.new_only == '1' : false;
        const with_hidden = params.with_hidden != undefined ? params.with_hidden == '1' : false;
        delete params.new_only;
        delete params.with_hidden;
        if (new_only) {
          params.new_only = new_only;
        }
        if (with_hidden) {
          params.with_hidden = with_hidden;
        }
        console.log(buildFilter(params))
        state.filter = params

        return new Promise((resolve, reject) => {

            if (Object.values(params).length > 2) {
                commit('START_LOADING');

                vm.$db([
                    vm.$q(REPORT_DATA)
                        .raw(params.view == 'weight' ? 'reports.planfact' : 'reports.planfact.money')
                        .action(buildFilter(params)),
                ]).then(((result: ServerResult) => {
                    commit('SET_REPORT_DATA', result.getOperation(REPORT_DATA).getContent());
                    commit('LOADED_SUCCESS');

                    resolve();
                }));
            } else {
                resolve();
            }
        })
    },

    exportDataAsXLSX({rootState}, params) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            vm.$db([
                vm.$q('EXPORT')
                .raw(params.view == 'weight' ? 'reports.planfact.export' : 'reports.planfact.money.export')
                .action({ ...buildFilter(params), format: 'xlsx'})
            ]).then(((result: ServerResult) => {
                const exportOpContent = result.getOperation('EXPORT').getContent();
                const fToken = exportOpContent.token;
                const aToken = (rootState as any).ubic.token
                const fileUrl = `${process.env.VUE_APP_UBIC_SERVER_ADDRESS}/api/v1/exports/${fToken}?authorization=${aToken}`;
                saveAs(fileUrl, 'export.xlsx')

                resolve();
            }));
        })
    },

    exportDataAsPDF({rootState}, params) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            vm.$db([
                vm.$q('EXPORT')
                .raw(params.view == 'weight' ? 'reports.planfact.export' : 'reports.planfact.money.export')
                .action({ ...buildFilter(params), format: 'pdf'})
            ]).then(((result: ServerResult) => {
                const exportOpContent = result.getOperation('EXPORT').getContent();
                const fToken = exportOpContent.token;
                const aToken = (rootState as any).ubic.token
                const fileUrl = `${process.env.VUE_APP_UBIC_SERVER_ADDRESS}/api/v1/exports/${fToken}?authorization=${aToken}`;
                saveAs(fileUrl, 'export.pdf')

                resolve();
            }));
        })
    },

    exportData({state}, {is_new}) {
      return new Promise((resolve, reject) => {
        const csvContent: any[] = [];
        const header = ["Клиент", "Наименование", 'План', 'Факт', 'Дельта', 'Процент выполнения']

        if (is_new === '1') {
          state.data.current_month_weeks.map((item: any, idx: number) => {
            if (idx > 0) {
              header.push([moment(item).format('DD.MM.YYYY'), moment(item).endOf('week').format('DD.MM.YYYY')].join(' - '))
              header.push('')
            }
          })
        }

        csvContent.push(header);

        const sum: any = {};
        state.ds.forEach((rowArray: any) => {
          if (rowArray.current_month_plan > 0 ||
            rowArray.current_month_fact > 0 ||
            rowArray.current_month_delta > 0 ||
            rowArray.current_month_plan > 0) {
            const row = [
              rowArray.name,
              rowArray.dz_name,
              numeral(rowArray.current_month_plan).format('0.00'),
              numeral(rowArray.current_month_fact).format('0.00'),
              numeral(rowArray.current_month_delta).format('0.00'),
              rowArray.current_month_plan > 0 ? numeral(rowArray.current_month_fact / rowArray.current_month_plan).format('0.00') : 0,
            ];
            if (rowArray.products) {
              rowArray.products.forEach((product: any) => {
                if (product.type != 'container') {
                  return
                }
                if (sum[product.product_id] == undefined) {
                  sum[product.product_id] = {
                    name: product.product_name,
                    containers: {},
                  }
                }
                if (sum[product.product_id].containers[product.product_container_name] == undefined) {
                  sum[product.product_id].containers[product.product_container_name] = {
                    name: product.product_container_name,
                    count: 0,
                    count_fact: 0,
                    weeks: []
                  }
                }
                sum[product.product_id].containers[product.product_container_name].count += product.current_month_plan
                sum[product.product_id].containers[product.product_container_name].count_fact += product.current_month_fact
                product.weeks.forEach((item: any, idx: number) =>{
                    if (!sum[product.product_id].containers[product.product_container_name].weeks[idx]) {
                        sum[product.product_id].containers[product.product_container_name].weeks[idx] = [0, 0]
                    }
                    sum[product.product_id].containers[product.product_container_name].weeks[idx][0] += item.plan
                    sum[product.product_id].containers[product.product_container_name].weeks[idx][1] += item.fact
                })
              })
            }
            if (rowArray.weeks && is_new === '1') {
              rowArray.weeks.forEach((week: any, idx: number) => {
                if (idx > 0 && idx <= state.data.current_month_weeks.length) {
                  row.push(week.plan)
                  row.push(week.fact)
                }
              });
            }
            csvContent.push(row);
          }
        });
        csvContent.push([]);
        csvContent.push([]);
        csvContent.push([]);
        const _header = ['Продукты', 'Тара', 'План', 'Факт']
        if (is_new === '1') {
          state.data.current_month_weeks.map((item: any, idx: number) => {
            if (idx > 0) {
              _header.push([moment(item).format('DD.MM.YYYY'), moment(item).endOf('week').format('DD.MM.YYYY')].join(' - '))
              _header.push('*')
            }
          })
        }
        csvContent.push(_header)

        Object.keys(sum).forEach((key: any) => {
          const item = sum[key];
          Object.keys(item.containers).forEach((key: any) => {
            const container = item.containers[key];
            const row = [
              item.name,
              container.name,
              container.count,
              container.count_fact,
            ]
            if (is_new === '1') {
                container.weeks.forEach((w: any, idx: number) => {
                if(idx > 0 && idx <= state.data.current_month_weeks.length) {
                    row.push(w[0])
                    row.push(w[1])
                }
                })
            }
            csvContent.push(row)
          });
          csvContent.push([]);
        });
        resolve(csvContent)
      })
    }

};

export const mutations: MutationTree<DealReportsState> = {
    START_LOADING: (state) => {
        state.loaded = false;
        state.loading = true;
        state.fatalError = false;
    },
    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = false;
    },
    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.fatalError = true;
    },

    SET_REPORT_DATA(state, data) {
        state.data = data;

      if (!data) return;

      state.ds = data.data.reduce((ac: any[], category: any) => {
        const categoryData: any = {
          type: 'category',
          name: category.client_category_profit
        };

        ac.push(categoryData);

        for (const client of category.clients) {
          let products: any[] = [];

          for (const product of client.products) {
            const containers = [];

            for (const container of product.product_containers) {

              const current_month_plan = container.weeks.reduce((ac: any, row: any) => {
                return ac + row.plan || 0;
              }, 0);

              const current_prime_costs = container.weeks.reduce((ac: any, row: any) => {
                return ac +  (row.plan - row.prime_costs) || 0;
              }, 0);

              const current_fact_costs = container.weeks.reduce((ac: any, row: any) => {
                return ac + row.fact_costs || 0;
              }, 0);

              const current_fact_prime_costs = container.weeks.reduce((ac: any, row: any) => {
                return ac + row.fact_prime_costs || 0;
              }, 0);

              const current_month_delta = current_month_plan - container.current_month_fact;
              let current_month_percent = 0;
              if (current_month_plan > 0) {
                current_month_percent = container.current_month_fact / current_month_plan * 100;
              } else {
                current_month_percent = 0;
              }

              containers.push({
                type: 'container',
                ...container,
                product_id: product.product_id,
                name: `${product.product_name} - ${container.product_container_name}`,
                product_name: product.product_name,
                container_name: container.product_container_name,
                current_prime_costs,
                current_fact_costs,
                current_month_plan,
                current_month_delta,
                current_month_percent,
                current_fact_prime_costs,
                client_id: (client as any).client_id,
              });
            }

            //
            // const current_month_plan = product.weeks.reduce((ac: any, row: any) => {
            //   return ac + row.plan || 0;
            // }, 0);

            // const current_month_delta = current_month_plan - product.current_month_fact;

            // products.push();

            products = [
              ...products,
              {
                type: 'product',
                ...product,
                id: product.product_id,
                name: product.product_name,
                prev_months_facts: containers.reduce((ac, current) => {
                  for(const key in current.prev_months_facts) {
                    ac[key] = ac[key] ? ac[key] + current.prev_months_facts[key] : current.prev_months_facts[key];
                  }

                  return ac;
                }, []),
                prev_months_average: containers.reduce((ac, current) => ac + current.prev_months_average, 0),
                current_month_prev_year_fact: containers.reduce((ac, current) => ac + current.current_month_prev_year_fact, 0),
                current_month_fact: containers.reduce((ac, current) => ac + current.current_month_fact, 0),
                current_month_plan: containers.reduce((ac, current) => ac + current.current_month_plan, 0),
                current_prime_costs: containers.reduce((ac, current) => ac + current.current_prime_costs, 0),
                current_fact_costs: containers.reduce((ac, current) => ac + current.current_fact_costs, 0),
                current_fact_prime_costs: containers.reduce((ac, current) => ac + current.current_fact_prime_costs, 0),
                current_month_delta: containers.reduce((ac, current) => ac + current.current_month_delta, 0),
                weeks: containers.reduce((ac, current) => {
                  for(const key in current.weeks) {
                    if(!ac[key]) {
                      ac[key] = {};
                    }

                    ac[key].plan = (ac[key].plan || 0) + current.weeks[key].plan;
                    ac[key].fact = (ac[key].fact || 0) + current.weeks[key].fact;
                    ac[key].prime_costs = (ac[key].prime_costs || 0) + current.weeks[key].plan - current.weeks[key].prime_costs;
                    ac[key].fact_costs = (ac[key].fact_costs || 0) + current.weeks[key].fact_costs;
                    ac[key].fact_prime_costs = (ac[key].fact_prime_costs || 0) + current.weeks[key].fact_prime_costs;
                  }

                  return ac;
                }, []),
                client_id: (client as any).client_id,
              },
              ...containers
            ]
          }

          const cleanProducts = products.filter((product: any) => product.type =='product').sort((a, b) => {
            if (a.current_month_fact > b.current_month_fact) {
              return -1
            } else if (a.current_month_fact < b.current_month_fact) {
              return 1
            } else {
              return 0
            }
          })

          const clientData: any = {
            type: 'client',
            name: (client as any).client_name,
            dz_name: (client as any).dz_name,
            client_id: (client as any).client_id,
            isExpanded: (client as any).isExpanded,

            prev_months_facts: cleanProducts.reduce((ac, current) => {
              for(const key in current.prev_months_facts) {
                ac[key] = ac[key] ? ac[key] + current.prev_months_facts[key] : current.prev_months_facts[key];
              }

              return ac;
            }, []),
            prev_months_average: cleanProducts.reduce((ac, current) => ac + current.prev_months_average, 0),
            current_month_prev_year_fact: cleanProducts.reduce((ac, current) => ac + current.current_month_prev_year_fact, 0),
            current_month_fact: cleanProducts.reduce((ac, current) => ac + current.current_month_fact, 0),
            current_month_plan: cleanProducts.reduce((ac, current) => ac + current.current_month_plan, 0),
            current_month_delta: cleanProducts.reduce((ac, current) => ac + current.current_month_delta, 0),
            current_prime_costs: cleanProducts.reduce((ac, current) => ac + current.current_prime_costs, 0),
            current_fact_costs: cleanProducts.reduce((ac, current) => ac + current.current_fact_costs, 0),
            current_fact_prime_costs: cleanProducts.reduce((ac, current) => ac + current.current_fact_prime_costs, 0),
            weeks: cleanProducts.reduce((ac, current) => {
              for(const key in current.weeks) {
                if(!ac[key]) {
                  ac[key] = {};
                }

                ac[key].plan = (ac[key].plan || 0) + current.weeks[key].plan;
                ac[key].fact = (ac[key].fact || 0) + current.weeks[key].fact;
                ac[key].prime_costs = (ac[key].prime_costs || 0) + current.weeks[key].plan - current.weeks[key].prime_costs;
                ac[key].fact_costs = (ac[key].fact_costs || 0) + current.weeks[key].fact_costs;
                ac[key].fact_prime_costs = (ac[key].fact_prime_costs || 0) + current.weeks[key].fact_prime_costs;
              }

              return ac;
            }, []),
          };

          clientData.products = products;

          ac.push(clientData);

          categoryData.prev_months_facts = clientData.prev_months_facts.reduce((ac: any, current: any, mInd: any) => {
            ac[mInd] = ac[mInd] ? ac[mInd] + current : current;

            return ac;
          }, categoryData.prev_months_facts || []),
          categoryData.prev_months_average = (categoryData.prev_months_average || 0) + clientData.prev_months_average;
          categoryData.current_month_prev_year_fact = (categoryData.current_month_prev_year_fact || 0) + clientData.current_month_prev_year_fact;
          categoryData.current_month_fact = (categoryData.current_month_fact || 0) + clientData.current_month_fact;
          categoryData.current_month_plan = (categoryData.current_month_plan || 0) + clientData.current_month_plan;
          categoryData.current_month_delta = (categoryData.current_month_delta || 0) + clientData.current_month_delta;
          categoryData.current_prime_costs = (categoryData.current_prime_costs || 0) + clientData.current_prime_costs;
          categoryData.current_fact_costs = (categoryData.current_fact_costs || 0) + clientData.current_fact_costs;
          categoryData.current_fact_prime_costs = (categoryData.current_fact_prime_costs || 0) + clientData.current_fact_prime_costs;
          categoryData.weeks = clientData.weeks.reduce((ac: any, current: any, wInd: any) => {
            if (!ac[wInd]) { ac[wInd] = {}; }

            ac[wInd].plan = (ac[wInd].plan || 0) + current.plan;
            ac[wInd].fact = (ac[wInd].fact || 0) + current.fact;
            ac[wInd].prime_costs = (ac[wInd].prime_costs || 0) + current.plan - current.prime_costs;
            ac[wInd].fact_costs = (ac[wInd].fact_costs || 0) + current.fact_costs;
            ac[wInd].fact_prime_costs = (ac[wInd].fact_prime_costs || 0) + current.fact_prime_costs;

            return ac;
          }, categoryData.weeks || []);

        }

        return ac
      }, []).filter((item: any) => {
        return item.current_month_plan > 0 ||
        item.current_month_fact > 0 ||
        item.current_month_delta > 0 ||
        item.current_month_plan > 0
      });

      const _tmp: any = {}
      let _category: string = ''

      state.ds.forEach((e: any) => {
        if (_category == '' || e.type == 'category') {
          _category = e.name;
          _tmp[_category + '-pfx'] = e
          _tmp[_category + '-w'] = []
        } else {
          _tmp[_category + '-w'].push(e)
        }
      })
      Object.keys(_tmp).forEach((key: string) => {
        const item: any = _tmp[key]
        if (!key.endsWith('-pfx')) {
          _tmp[key] = item.sort((a: any, b: any) => {
            if (a.current_month_fact > b.current_month_fact) {
              return -1
            } else if (a.current_month_fact < b.current_month_fact) {
              return 1
            } else {
              return 0
            }
          })
        }
      })
      state.ds = Object.values(_tmp).flat()

      const categories = state.ds.filter((row: any) => row.type === 'category');
      const summaryData: any = {
        type: 'summary',
        name: 'Общие итоги',

        prev_months_facts: categories.reduce((ac: any, current: any) => {
          for(const key in current.prev_months_facts) {
            ac[key] = ac[key] ? ac[key] + current.prev_months_facts[key] : current.prev_months_facts[key];
          }

          return ac;
        }, []),
        prev_months_average: categories.reduce((ac, current) => ac + current.prev_months_average, 0),
        current_month_prev_year_fact: categories.reduce((ac, current) => ac + current.current_month_prev_year_fact, 0),
        current_month_fact: categories.reduce((ac, current) => ac + current.current_month_fact, 0),
        current_month_plan: categories.reduce((ac, current) => ac + current.current_month_plan, 0),
        current_month_delta: categories.reduce((ac, current) => ac + current.current_month_delta, 0),
        current_prime_costs: categories.reduce((ac, current) => ac + current.current_prime_costs, 0),
        current_fact_costs: categories.reduce((ac, current) => ac + current.current_fact_costs, 0),
        current_fact_prime_costs: categories.reduce((ac, current) => ac + current.current_fact_prime_costs, 0),
        weeks: categories.reduce((ac, current) => {
          for(const key in current.weeks) {
            if(!ac[key]) {
              ac[key] = {};
            }

            ac[key].plan = (ac[key].plan || 0) + current.weeks[key].plan;
            ac[key].fact = (ac[key].fact || 0) + current.weeks[key].fact;
            ac[key].prime_costs = (ac[key].prime_costs || 0) + current.weeks[key].plan - current.weeks[key].prime_costs;
            ac[key].fact_costs = (ac[key].fact_costs || 0) + current.weeks[key].fact_costs;
            ac[key].fact_prime_costs = (ac[key].fact_prime_costs || 0) + current.weeks[key].fact_prime_costs;
          }

          return ac;
        }, []),
      };

      state.ds.unshift(summaryData);

      state.data.revision = state.data.revision || 0;
    },
};

const getters = {
  exportData(state: DealReportsState) {
    const csvContent: any[] = [];
    const sum: any = {};
    state.ds.forEach((rowArray: any) => {
      if (rowArray.current_month_plan > 0 ||
        rowArray.current_month_fact > 0 ||
        rowArray.current_month_delta > 0 ||
        rowArray.current_month_plan > 0) {
        const row = [
          rowArray.name,
          rowArray.dz_name,
          numeral(rowArray.current_month_plan).format('0.00'),
          numeral(rowArray.current_month_fact).format('0.00'),
          numeral(rowArray.current_month_delta).format('0.00'),
          rowArray.current_month_plan > 0 ? numeral(rowArray.current_month_fact / rowArray.current_month_plan).format('0.00') : 0,
        ];
        csvContent.push(row);
        if (rowArray.products) {
          rowArray.products.forEach((product: any) => {
            if (product.type != 'container') {
              return
            }
            if (sum[product.product_id] == undefined) {
              sum[product.product_id] = {
                name: product.product_name,
                containers: {},
              }
            }
            if (sum[product.product_id].containers[product.product_container_name] == undefined) {
              sum[product.product_id].containers[product.product_container_name] = {
                name: product.product_container_name,
                count: 0,
                count_fact: 0
              }
            }
            sum[product.product_id].containers[product.product_container_name].count += product.current_month_plan
            sum[product.product_id].containers[product.product_container_name].count_fact += product.current_month_fact
          })
        }
      }
    });
    csvContent.push([]);
    csvContent.push([]);
    csvContent.push([]);
    csvContent.push(['Продукты', 'Тара', 'План', 'Факт']);
    Object.keys(sum).forEach((key: any) => {
      const item = sum[key];
      console.log(key, item)
      Object.keys(item.containers).forEach((key: any) => {
        const container = item.containers[key];
        console.log(key, container)
        csvContent.push([
          item.name,
          container.name,
          container.count,
          container.count_fact
        ]);
      });
      csvContent.push([]);
    });
    return csvContent
  }
};

export const STORE_KEY = '$_deal_reports';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
